/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Payment link with no amount, as the payer sees it
 */
export type OpenPaymentLinkPublicDTO = {
  description?: string;
  /**
   * When true, the logo is served by GET .../public/{linkKey}/logo
   */
  hasLogo?: boolean;
  id?: string;
  merchantTradingName?: string;
  /**
   * Where the payer is sent after a successful payment; null when not set
   */
  redirectUrl?: string;
  /**
   * Shown to the payer after a successful payment; null when not set
   */
  returnMessage?: string;
  slug?: string;
  status?: OpenPaymentLinkPublicDTO.status;
  title?: string;
};

export namespace OpenPaymentLinkPublicDTO {
  export enum status {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
  }
}
